import rhinoSession from 'rhino/src/components/session/session.module';

import * as rnInvitation from './invitation.service';

export default angular.module('rhino.components.invitation', [rhinoSession])
  .factory(rnInvitation.name, rnInvitation.default)
  .name;



// WEBPACK FOOTER //
// ../~/@printos/rhino/src/components/invitation/invitation.module.js